// source: suggestions.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require("google-protobuf");
var goog = jspb;
var global = function () {
  return this || window || global || self || Function("return this")();
}.call(null);

goog.exportSymbol("proto.com.cisco.wcc.ccai.v1.AgentAnswer", null, global);
goog.exportSymbol(
  "proto.com.cisco.wcc.ccai.v1.AgentAnswerResult",
  null,
  global
);
goog.exportSymbol(
  "proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.AnswerOneofCase",
  null,
  global
);
goog.exportSymbol("proto.com.cisco.wcc.ccai.v1.Answer", null, global);
goog.exportSymbol("proto.com.cisco.wcc.ccai.v1.range", null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    null,
    proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.oneofGroups_
  );
};
goog.inherits(proto.com.cisco.wcc.ccai.v1.AgentAnswerResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.displayName =
    "proto.com.cisco.wcc.ccai.v1.AgentAnswerResult";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.cisco.wcc.ccai.v1.AgentAnswer.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.cisco.wcc.ccai.v1.AgentAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.cisco.wcc.ccai.v1.AgentAnswer.displayName =
    "proto.com.cisco.wcc.ccai.v1.AgentAnswer";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.cisco.wcc.ccai.v1.Answer = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.com.cisco.wcc.ccai.v1.Answer.repeatedFields_,
    null
  );
};
goog.inherits(proto.com.cisco.wcc.ccai.v1.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.cisco.wcc.ccai.v1.Answer.displayName =
    "proto.com.cisco.wcc.ccai.v1.Answer";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.cisco.wcc.ccai.v1.range = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.cisco.wcc.ccai.v1.range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.cisco.wcc.ccai.v1.range.displayName =
    "proto.com.cisco.wcc.ccai.v1.range";
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.AnswerOneofCase = {
  ANSWER_ONEOF_NOT_SET: 0,
  AGENTANSWER: 2,
};

/**
 * @return {proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.AnswerOneofCase}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.getAnswerOneofCase =
  function () {
    return /** @type {proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.AnswerOneofCase} */ (
      jspb.Message.computeOneofCase(
        this,
        proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.oneofGroups_[0]
      )
    );
  };

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        agentanswer:
          (f = msg.getAgentanswer()) &&
          proto.com.cisco.wcc.ccai.v1.AgentAnswer.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.deserializeBinary = function (
  bytes
) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.cisco.wcc.ccai.v1.AgentAnswerResult();
  return proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 2:
          var value = new proto.com.cisco.wcc.ccai.v1.AgentAnswer();
          reader.readMessage(
            value,
            proto.com.cisco.wcc.ccai.v1.AgentAnswer.deserializeBinaryFromReader
          );
          msg.setAgentanswer(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.serializeBinary =
  function () {
    var writer = new jspb.BinaryWriter();
    proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getAgentanswer();
    if (f != null) {
      writer.writeMessage(
        2,
        f,
        proto.com.cisco.wcc.ccai.v1.AgentAnswer.serializeBinaryToWriter
      );
    }
  };

/**
 * optional AgentAnswer agentanswer = 2;
 * @return {?proto.com.cisco.wcc.ccai.v1.AgentAnswer}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.getAgentanswer =
  function () {
    return /** @type{?proto.com.cisco.wcc.ccai.v1.AgentAnswer} */ (
      jspb.Message.getWrapperField(
        this,
        proto.com.cisco.wcc.ccai.v1.AgentAnswer,
        2
      )
    );
  };

/**
 * @param {?proto.com.cisco.wcc.ccai.v1.AgentAnswer|undefined} value
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.setAgentanswer =
  function (value) {
    return jspb.Message.setOneofWrapperField(
      this,
      2,
      proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswerResult} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.clearAgentanswer =
  function () {
    return this.setAgentanswer(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswerResult.prototype.hasAgentanswer =
  function () {
    return jspb.Message.getField(this, 2) != null;
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.repeatedFields_ = [1, 2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.com.cisco.wcc.ccai.v1.AgentAnswer.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.cisco.wcc.ccai.v1.AgentAnswer.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        answersList: jspb.Message.toObjectList(
          msg.getAnswersList(),
          proto.com.cisco.wcc.ccai.v1.Answer.toObject,
          includeInstance
        ),
        tagsList:
          (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.cisco.wcc.ccai.v1.AgentAnswer();
  return proto.com.cisco.wcc.ccai.v1.AgentAnswer.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.cisco.wcc.ccai.v1.Answer();
        reader.readMessage(
          value,
          proto.com.cisco.wcc.ccai.v1.Answer.deserializeBinaryFromReader
        );
        msg.addAnswers(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addTags(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.serializeBinary =
  function () {
    var writer = new jspb.BinaryWriter();
    proto.com.cisco.wcc.ccai.v1.AgentAnswer.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.cisco.wcc.ccai.v1.Answer.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(2, f);
  }
};

/**
 * repeated Answer answers = 1;
 * @return {!Array<!proto.com.cisco.wcc.ccai.v1.Answer>}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.getAnswersList = function () {
  return /** @type{!Array<!proto.com.cisco.wcc.ccai.v1.Answer>} */ (
    jspb.Message.getRepeatedWrapperField(
      this,
      proto.com.cisco.wcc.ccai.v1.Answer,
      1
    )
  );
};

/**
 * @param {!Array<!proto.com.cisco.wcc.ccai.v1.Answer>} value
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.setAnswersList = function (
  value
) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.cisco.wcc.ccai.v1.Answer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.addAnswers = function (
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.com.cisco.wcc.ccai.v1.Answer,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.clearAnswersList =
  function () {
    return this.setAnswersList([]);
  };

/**
 * repeated string tags = 2;
 * @return {!Array<string>}
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.getTagsList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};

/**
 * @param {!Array<string>} value
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.setTagsList = function (
  value
) {
  return jspb.Message.setField(this, 2, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.addTags = function (
  value,
  opt_index
) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.cisco.wcc.ccai.v1.AgentAnswer} returns this
 */
proto.com.cisco.wcc.ccai.v1.AgentAnswer.prototype.clearTagsList = function () {
  return this.setTagsList([]);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.cisco.wcc.ccai.v1.Answer.repeatedFields_ = [3, 9];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.cisco.wcc.ccai.v1.Answer.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.com.cisco.wcc.ccai.v1.Answer.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.cisco.wcc.ccai.v1.Answer} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.cisco.wcc.ccai.v1.Answer.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        title: jspb.Message.getFieldWithDefault(msg, 1, ""),
        uri: jspb.Message.getFieldWithDefault(msg, 2, ""),
        snippetsList:
          (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
        description: jspb.Message.getFieldWithDefault(msg, 4, ""),
        confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        source: jspb.Message.getFieldWithDefault(msg, 6, ""),
        metadataMap: (f = msg.getMetadataMap())
          ? f.toObject(includeInstance, undefined)
          : [],
        answerRecord: jspb.Message.getFieldWithDefault(msg, 8, ""),
        highlightList: jspb.Message.toObjectList(
          msg.getHighlightList(),
          proto.com.cisco.wcc.ccai.v1.range.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer}
 */
proto.com.cisco.wcc.ccai.v1.Answer.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.cisco.wcc.ccai.v1.Answer();
  return proto.com.cisco.wcc.ccai.v1.Answer.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.cisco.wcc.ccai.v1.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer}
 */
proto.com.cisco.wcc.ccai.v1.Answer.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTitle(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setUri(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.addSnippets(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setConfidence(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setSource(value);
        break;
      case 7:
        var value = msg.getMetadataMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(
            message,
            reader,
            jspb.BinaryReader.prototype.readString,
            jspb.BinaryReader.prototype.readString,
            null,
            "",
            ""
          );
        });
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setAnswerRecord(value);
        break;
      case 9:
        var value = new proto.com.cisco.wcc.ccai.v1.range();
        reader.readMessage(
          value,
          proto.com.cisco.wcc.ccai.v1.range.deserializeBinaryFromReader
        );
        msg.addHighlight(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.cisco.wcc.ccai.v1.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.cisco.wcc.ccai.v1.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.cisco.wcc.ccai.v1.Answer.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getUri();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getSnippetsList();
  if (f.length > 0) {
    writer.writeRepeatedString(3, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeFloat(5, f);
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(
      7,
      writer,
      jspb.BinaryWriter.prototype.writeString,
      jspb.BinaryWriter.prototype.writeString
    );
  }
  f = message.getAnswerRecord();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getHighlightList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.com.cisco.wcc.ccai.v1.range.serializeBinaryToWriter
    );
  }
};

/**
 * optional string title = 1;
 * @return {string}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getTitle = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};

/**
 * @param {string} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setTitle = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string uri = 2;
 * @return {string}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getUri = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};

/**
 * @param {string} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setUri = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * repeated string snippets = 3;
 * @return {!Array<string>}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getSnippetsList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};

/**
 * @param {!Array<string>} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setSnippetsList = function (
  value
) {
  return jspb.Message.setField(this, 3, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.addSnippets = function (
  value,
  opt_index
) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.clearSnippetsList = function () {
  return this.setSnippetsList([]);
};

/**
 * optional string description = 4;
 * @return {string}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};

/**
 * @param {string} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setDescription = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional float confidence = 5;
 * @return {number}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getConfidence = function () {
  return /** @type {number} */ (
    jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0)
  );
};

/**
 * @param {number} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setConfidence = function (value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};

/**
 * optional string source = 6;
 * @return {string}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getSource = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};

/**
 * @param {string} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setSource = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * map<string, string> metadata = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getMetadataMap = function (
  opt_noLazyCreate
) {
  return /** @type {!jspb.Map<string,string>} */ (
    jspb.Message.getMapField(this, 7, opt_noLazyCreate, null)
  );
};

/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.clearMetadataMap = function () {
  this.getMetadataMap().clear();
  return this;
};

/**
 * optional string answer_record = 8;
 * @return {string}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getAnswerRecord = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};

/**
 * @param {string} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setAnswerRecord = function (
  value
) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * repeated range highlight = 9;
 * @return {!Array<!proto.com.cisco.wcc.ccai.v1.range>}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.getHighlightList = function () {
  return /** @type{!Array<!proto.com.cisco.wcc.ccai.v1.range>} */ (
    jspb.Message.getRepeatedWrapperField(
      this,
      proto.com.cisco.wcc.ccai.v1.range,
      9
    )
  );
};

/**
 * @param {!Array<!proto.com.cisco.wcc.ccai.v1.range>} value
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.setHighlightList = function (
  value
) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};

/**
 * @param {!proto.com.cisco.wcc.ccai.v1.range=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.cisco.wcc.ccai.v1.range}
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.addHighlight = function (
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    9,
    opt_value,
    proto.com.cisco.wcc.ccai.v1.range,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.cisco.wcc.ccai.v1.Answer} returns this
 */
proto.com.cisco.wcc.ccai.v1.Answer.prototype.clearHighlightList = function () {
  return this.setHighlightList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.cisco.wcc.ccai.v1.range.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.com.cisco.wcc.ccai.v1.range.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.cisco.wcc.ccai.v1.range} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.cisco.wcc.ccai.v1.range.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        start: jspb.Message.getFieldWithDefault(msg, 1, 0),
        end: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.cisco.wcc.ccai.v1.range}
 */
proto.com.cisco.wcc.ccai.v1.range.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.cisco.wcc.ccai.v1.range();
  return proto.com.cisco.wcc.ccai.v1.range.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.cisco.wcc.ccai.v1.range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.cisco.wcc.ccai.v1.range}
 */
proto.com.cisco.wcc.ccai.v1.range.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStart(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setEnd(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.cisco.wcc.ccai.v1.range.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.cisco.wcc.ccai.v1.range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.cisco.wcc.ccai.v1.range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.cisco.wcc.ccai.v1.range.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional int32 start = 1;
 * @return {number}
 */
proto.com.cisco.wcc.ccai.v1.range.prototype.getStart = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.com.cisco.wcc.ccai.v1.range} returns this
 */
proto.com.cisco.wcc.ccai.v1.range.prototype.setStart = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 end = 2;
 * @return {number}
 */
proto.com.cisco.wcc.ccai.v1.range.prototype.getEnd = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/**
 * @param {number} value
 * @return {!proto.com.cisco.wcc.ccai.v1.range} returns this
 */
proto.com.cisco.wcc.ccai.v1.range.prototype.setEnd = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

goog.object.extend(exports, proto.com.cisco.wcc.ccai.v1);
